(function () {
  var grid = document.querySelector('.laylo-philosophy__stats-grid');
  if (!grid) return;

  var items = Array.from(grid.querySelectorAll('.laylo-stat-item'));
  var triggered = false;

  var observer = new IntersectionObserver(function (entries) {
    if (triggered || !entries[0].isIntersecting) return;
    triggered = true;

    items.forEach(function (item, i) {
      setTimeout(function () {
        item.classList.add('is-visible');
      }, i * 220);
    });

    observer.disconnect();
  }, { threshold: 0.3 });

  observer.observe(grid);
})();
